<section class="qbf-shell" [class.qbf-modal-shell]="isModalMode" *ngIf="!loading; else loadingBlock">
  <div class="qbf-card" [class.qbf-card-modal]="isModalMode">
    <header class="qbf-header">
      <h2>{{ isEditMode ? 'Edit question' : 'Add new question' }}</h2>
      <button class="qbf-close" *ngIf="isModalMode" type="button" (click)="cancel()" aria-label="Close">×</button>
    </header>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="qbf-form">
      <div class="qbf-main-fields">
        <label class="qbf-label">Question title</label>
        <input class="qbf-input" type="text" formControlName="title" maxlength="255" />

        <label class="qbf-label">Question text</label>
        <textarea class="qbf-input" rows="3" formControlName="questionText"></textarea>

        <label class="qbf-label">Tags</label>
        <div class="qbf-tags-box">
          <div class="qbf-tag-list" *ngIf="tags.length > 0">
            <button
              class="qbf-tag-pill"
              type="button"
              *ngFor="let tag of tags"
              (click)="removeTag(tag)"
              [attr.aria-label]="'Remove tag ' + tag"
            >
              {{ tag }} <strong>&times;</strong>
            </button>
          </div>

          <input
            class="qbf-tag-input"
            type="text"
            [ngModel]="tagInputText"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onTagInputChange($event)"
            (keydown)="onTagInputKeydown($event)"
            placeholder="Type a tag and press comma"
          />
        </div>

        <div class="qbf-row two-col">
          <div>
            <label class="qbf-label">Type of question</label>
            <div class="qbf-type-grid" [class.disabled]="isEditMode">
              <button
                type="button"
                class="qbf-type-item"
                *ngFor="let option of questionTypeOptions"
                [class.active]="selectedType === option.value"
                [disabled]="isEditMode"
                (click)="selectType(option.value)"
              >
                <span class="qbf-type-square"></span>
                <span>{{ option.label }}</span>
              </button>
            </div>
          </div>

          <div>
            <label class="qbf-label">Difficulty</label>
            <select class="qbf-input" formControlName="difficulty">
              <option *ngFor="let option of difficultyOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>
        </div>

        <div class="qbf-row" *ngIf="isEditMode">
          <div>
            <label class="qbf-label">Status</label>
            <select class="qbf-input" formControlName="isActive">
              <option [ngValue]="true">Active</option>
              <option [ngValue]="false">Inactive</option>
            </select>
          </div>
        </div>
      </div>

      <div class="qbf-divider"></div>

      <div [ngSwitch]="selectedType" class="qbf-type-section">
        <div *ngSwitchCase="QuestionType.MultipleChoice">
          <label class="qbf-label">Options</label>

          <div formArrayName="multipleChoiceOptions" class="qbf-option-list">
            <div class="qbf-option-row" *ngFor="let optionControl of multipleChoiceOptionsArray.controls; let i = index">
              <label class="qbf-correct-check" [attr.aria-label]="'Correct answer for option ' + (i + 1)">
                <input type="checkbox" [formControl]="multipleChoiceCorrectFlagsArray.at(i)" />
                <span>Correct</span>
              </label>

              <input
                class="qbf-input"
                type="text"
                [formControlName]="i"
                [placeholder]="'Option ' + (i + 1)"
              />

              <button
                class="qbf-remove-btn"
                type="button"
                (click)="removeMultipleChoiceOption(i)"
                [disabled]="multipleChoiceOptionsArray.length <= 2"
              >
                ×
              </button>
            </div>
          </div>

          <div class="qbf-helper-row">
            <small>Mark correct answers with the checkbox. Multiple checks enable multiple selection.</small>
            <button class="qbf-secondary-btn" type="button" (click)="addMultipleChoiceOption()">+ Add option</button>
          </div>
        </div>

        <div *ngSwitchCase="QuestionType.CodeCompletion">
          <label class="qbf-label">Code snippet</label>
          <textarea class="qbf-input" rows="6" formControlName="codeSnippet"></textarea>

          <label class="qbf-label mt-3">Accepted answers (one per line)</label>
          <textarea class="qbf-input" rows="4" formControlName="acceptedAnswersText"></textarea>
        </div>

        <div *ngSwitchCase="QuestionType.OpenEnded">
          <label class="qbf-label">Answer</label>
          <input class="qbf-input" type="text" formControlName="fillInAnswer" />
        </div>

        <div *ngSwitchCase="QuestionType.TrueFalse">
          <label class="qbf-label">Correct answer</label>
          <select class="qbf-input" formControlName="trueFalseCorrectAnswer">
            <option [ngValue]="true">True</option>
            <option [ngValue]="false">False</option>
          </select>

          <label class="qbf-label mt-3">Explanation (optional)</label>
          <textarea class="qbf-input" rows="3" formControlName="trueFalseExplanation"></textarea>
        </div>
      </div>

      <div class="qbf-divider"></div>

      <div class="qbf-actions">
        <button class="qbf-submit" type="submit" [disabled]="saving">
          {{ saving ? 'Saving...' : (isEditMode ? 'Update' : 'Save') }}
        </button>
        <button class="qbf-cancel" type="button" (click)="cancel()" [disabled]="saving">Cancel</button>
      </div>
    </form>
  </div>
</section>

<ng-template #loadingBlock>
  <section class="qbf-shell" [class.qbf-modal-shell]="isModalMode">
    <div class="qbf-card" [class.qbf-card-modal]="isModalMode">
      <div class="qbf-loading">Loading question...</div>
    </div>
  </section>
</ng-template>
